import 'formdata-polyfill';
import './class-list-polyfill';
import './remove-polyfill';